import React, { useContext, useState, useEffect } from "react";
import { Grid, Row, Col, Tab, Tabs, Modal } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import BootstrapTable from "react-bootstrap-table-next";
import BeatLoader from "react-spinners/BeatLoader";
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import SimpleReactValidator from 'simple-react-validator';
import { MDBRow, MDBCol } from 'mdbreact';
import moment from 'moment';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import ModalBox from '../components/ModalBox/ModalBox';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { isEmpty } from "components/Login/validator";
import 'assets/css/custom.css';
import { PostAPI } from "api/post";
import { getStatusAlert } from "utilities/CommonUtils";

const cookies = new Cookies();


const Role = props => {
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let featureId = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].featureId
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const { SearchBar, ClearSearchButton } = Search;
  const [prop,setProp] = useState()
  let[commonTitle, setCommonTitle] = useState("");
  const divRef = React.useRef()
  const [showFilter, setshowFilter] = useState(false);
  const [showCSearch, setshowCSearch] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [key, setKey] = useState();
  let [values, setValues] = useState();
  const { t, i18n } = useTranslation();
  let [loadTableData, setloadTableData] = useState(true);
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [page, setpage] = useState(1);
  let [sizePerPage, setsizePerPage] = useState(10);
  let [modalType, setmodalType] = useState(`${t("add")}`);
  let [uniqueId, setuniqueId] = useState();
  let [extraId, setextraId] = useState();
  let [searchInputValue, setsearchInputValue] = useState();
  let [modalgetURL, setmodalgetURL] = useState('');
  let [dropDownApi, setDropDownApi] = useState();
  let [saveUrl, setSaveUrl] = useState();
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [renderComponent, setRenderComponent] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [iotQty, setIotQty] = useState();
  let [downloaded, setDownloaded] = useState('');
  let [assigned, setAssigned] = useState('');
  let [modalTitle, setModalTitle] = useState('');
  let [modalWidth, setModalWidth] = useState();
  let [table, setTable] = useState(false);
  const [showTPModal, setshowTPModal] = useState(false);
  const [productsDataChild, setproductsDataChild] = useState([]);
  const [loadTableDataChild, setloadTableDataChild] = useState(true);
  const [columnsChild, setColumnsChild] = useState([]);
  const [tpPermission, setTpPermission] = useState(null);
  const [syncPermission, setSyncPermission] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false);
  const [syncValue, setSyncValue] = useState(null)
  const [disableReloadIcon, setDisableReloadIcon] = useState(false)
  const [selectOption, setSelectOption] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [syncSapMessage, setSyncSapMessage] = useState({
    status: null,
    message: null
  })
  let [headers, setHeaders] = useState(null);
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const initialRenderColumns = [{
    dataField: "serial_no",
    text: "Serial No."
  },
  {
    dataField: "role_name",
    text: "Role Name"
  },
  {
    dataField: "customer_name",
    text: "Customer Name"
  }]
  const [assignedColumns, setAssignedColumns] = useState(initialRenderColumns);
  const [downloadedColumns, setDownloadedColumns] = useState(initialRenderColumns);
  const [assignedProductsData, setAssignedProductsData] = useState([]);
  const [downloadedProductsData , setDownloadedProductsData] = useState([]);
  const [assignedRecords, setAssignedRecords] = useState();
  const [downloadedRecords, setDownloadedRecords] = useState();
  const myRef = React.useRef(null);
  let [formValues, setformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'

  let dynamicParameters = {
   user_id:cookies.get('user_id'),
   customer_id:cookies.get('customer_id'),
   userLocation_id:cookies.get('userLocation_id'),
   userRole_name:cookies.get('userRole_name'),
   language: language
  }

  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  const formElementsArray = [];
  for (let key in ModalformValues) {
    formElementsArray.push({
      id: key,
      config: ModalformValues[key]
    });
  }



  const inputChangedHandler = (event, inputIdentifier) => {
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  }

  
  
 

  const actionsColumn = (responseDataJson) =>  {
    let tabKey = key
    const IsSyncToSap = pageLayoutData[1].title1 === "Inventory Sync to";
    const titles = ["Download Serial Number","Download Reclamation PO","Download Buffer IOT's"]
    const isDownloadSerialNumber = ((cookies.get('customer_id') === '12') && (titles.includes(pageLayoutData[0].addTextName1)))
    if (!isEmpty(responseDataJson.data.data)) {
      if (pageLayoutData[0].addButtonType == 'modal') {
        for (let [key, value] of Object.entries(responseDataJson.data.data)) {
          value.action = <div className="action-styles" >
            {responseDataJson.data.editPermission == true ? <a onClick={(e) => editOpenModal(e, value.id)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
            {tabKey === 'bulk download' && pageLayoutData[1].title2 === 'Bulk Download' &&
             <i style={{ cursor: 'pointer' }} 
              onClick={() => window.location.href = value.filename}className="fa fa-download-square-o fa-download">
             </i>}
             {(isDownloadSerialNumber && ("download_file_path" in value && value.download_file_path)) && <i onClick={() => window.location.href = value.download_file_path} className="fa fa-download-square-o fa-download refresh-icon"></i>}   
            {(value.download == true && value.download_token == undefined && value.vid_download_token == undefined && pageLayoutData[0].reportFlag !== true) ? <a onClick={(e) => exportOpenModal(e, value)}><i className="fa fa-download-square-o fa-download"></i></a> : ''}
            {(!isDownloadSerialNumber) && ((value.download == true && value.qty !== 0) && (value?.download_token || value?.vid_download_token)) ? <a onClick={(e) => exportResModal(e, value)}><i className="fa fa-download-square-o fa-download"></i></a> : ''}
            {value.download && pageLayoutData[0].reportFlag && <i onClick={(() => handleReportActions(value,"download"))} className={`fa fa-download-square-o fa-download refresh-icon ${value.status === "Ready to download" ? "processed" : value.status === "Processing" ? "processing" : ""}`} />}
            {value.mail && pageLayoutData[0].reportFlag && <i onClick={(() => handleReportActions(value,"mail"))} className={`fa fa-envelope refresh-icon ${value.status === "Ready to download" ? "" : "processing-mail"}`} />}
            {responseDataJson.data.deletePermission == true ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
            {IsSyncToSap && <i onClick={(e) => handleSyncToSap(value)} className={`fa fa-info-circle refresh-icon ${value.reload == 2 ? "refresh-warn" : ""}`}/>}
            {((value.reload == 0 || value.reload == 2) && (cookies.get('customer_id') == 15))
            && <i onClick={(e) => handleSyncReload(value)} className={`fa fa-refresh refresh-icon`} />} 
          </div>;
        }
      } 
      else {
        for (let [key, value] of Object.entries(responseDataJson.data.data)) {
          value.action = <div>
            {responseDataJson.data.deletePermission == true ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
          </div>;
          if (value.image) {
            value.image = <div>
              <img src={value.image} alt="no img" width="50" height="50" />
            </div>;
          }
          if (value.pdf) {
            value.pdf = <div>
              <a onclick={(e) => exportPdf(e, value.pdf)}><i className="fa fa-download-square-o fa-download"></i></a>
            </div>;
          }
  }
      }
    }
  }
 
  async function searchTableData(data) {
    setloadTableData(false);
    let startFrom = 0;
    let modifiedTab;
    let cpage = 0
    let searchFormData = {};
    let totalParams;
    let getURL;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
      switch(key){
        case pageLayoutData[1].subComponentsItems.tabName1:
        default:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
          totalParams = { ...totalParams, mode: key }
          break;
        case pageLayoutData[1].subComponentsItems.tabName2:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
          totalParams = { ...totalParams, mode: key }
          break;
      }
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in data) {
       if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
      totalParams.start_from = startFrom;
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL;
      else
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        actionsColumn(responseDataJson)
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
                setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
            break;
        }
        setloadTableData(true);
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObj = {...newObj}
      else
      newestObj = {...newObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setloadTableData(true);
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function filteredExport(data) {
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    totalParams = { ...totalParams, mode: key }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
    }else {
      responseData = await PostAPI(getURL, newObj);
    }
    if(responseData.status == 200){
      swal('Your request is under process',
          'Shortly, you will receive an email with downlodable link','success')
      }
      else{
        swal('Something went wrong','Please download again','error')
      }
  }
  async function filteredExport1(data) {
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint1;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    totalParams = { ...totalParams, mode: key }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
    }else {
      responseData = await PostAPI(getURL, newObj);
    }
    if(responseData.status == 200){
      swal('Your request is under process',
          'Shortly, you will receive an email with downlodable link','success')
      }
      else{
        swal('Something went wrong','Please download again','error')
      }
  }
  async function clearTableData(event) {
    setValues();
    setloadTableData(false)
    let modifiedTab;
    let getURL;
    let totalParams;
    switch (key) {
      case pageLayoutData[1].subComponentsItems.tabName1:
        default:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
        break;
    }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = { ...totalParams, mode: key }
    totalParams = {...totalParams, ...dynamicParameters}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL;
      else
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        actionsColumn(responseDataJson)
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setformValues(pageLayoutData[0].formValues);
        setIotQty(pageLayoutData[1].title1 === 'Assign' ? responseDataJson.data.IOTQty : responseDataJson.data.availableQty)
        setshowFilter(!showFilter);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObj = {...totalParams}
      else
      newestObj = {...totalParams, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  const handleTableChange = (event, { page, sizePerPage }) => {
    if (event == 'search') {
      return;
    }
    const currentIndex = (page - 1) * sizePerPage;
    setpage(page);
    setsizePerPage(sizePerPage);
    handleLatestTableData(page);
    handlePageChange(page);
  }

  const MySearch = (props) => {
    let input;
    const changeInputFunction = (e,input) => {
      if(e.which === 13){
        handleClick();
      }
      if(e.which === 32 && !input.value.length)
      swal({title:`${t("alerts.spaces_not_allowed")}`, text:`${t("alerts.search_is_restricted")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
    }

    const clearchangeInputFunction = (e,input) => {
      if(e.which === 8 && input.value.length === 1){
        clearSearchData(e);
      }
}
    const handleClick = async () => {
      if(input.value == ''){
      swal({title:`${t("alerts.enter_search")}`, text:`${t("alerts.value_to_search")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
        return false;
      }
      setloadTableData(false);
      props.onSearch(input.value);
      setsearchInputValue(input.value);
      let totalParams;
      let startFrom = 0;
      let searchFormData = {};
      let getURL
      switch (key) {
        case pageLayoutData[1].subComponentsItems.tabName1:
          default:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
          break;
        case pageLayoutData[1].subComponentsItems.tabName2:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
          break;
      }
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      } 
      totalParams = { ...totalParams, mode: key }
      totalParams= {...totalParams, start_from: startFrom, ...dynamicParameters}
      for (let formElementIdentifier in formValues) {
         if(formValues[formElementIdentifier].elementType === 'multiselect') {
          if((formValues[formElementIdentifier].value)) {
            let arrayConvert = [];
            formValues[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
          }
        else
          searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
      }
      totalParams = {...totalParams, element:input.value.replace(/^\s+|\s+$/gm,'')}
      let newObj = { ...searchFormData, ...totalParams}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          actionsColumn(responseDataJson)
          setpage(1);
          switch (key) {
            case pageLayoutData[1].subComponentsItems.tabName1:
              default:
                setAssignedColumns(responseDataJson.data.columns); 
                setAssignedProductsData(responseDataJson.data.data);
                setAssignedRecords(responseDataJson.data.recordsTotal)
                setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
                break;
                case pageLayoutData[1].subComponentsItems.tabName2:
                  setDownloadedColumns(responseDataJson.data.columns); 
                  setDownloadedProductsData(responseDataJson.data.data)
                  setDownloadedRecords(responseDataJson.data.recordsTotal)
                  setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
              break;
          }
          setSelectedValue(1);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setformValues(pageLayoutData[0].formValues);
          setshowCSearch(true);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
        let responseData = await PostAPI(getURL, newObj);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          setpage(1);
          switch (key) {
            case pageLayoutData[1].subComponentsItems.tabName1:
              default:
                setAssignedColumns(responseDataJson.data.columns); 
                setAssignedProductsData(responseDataJson.data.data);
                setAssignedRecords(responseDataJson.data.recordsTotal)
                break;
                case pageLayoutData[1].subComponentsItems.tabName2:
                  setDownloadedColumns(responseDataJson.data.columns); 
                  setDownloadedProductsData(responseDataJson.data.data)
                  setDownloadedRecords(responseDataJson.data.recordsTotal)
              break;
          }
          setSelectedValue(1);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setformValues(pageLayoutData[0].formValues);
          setshowCSearch(true);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    }
    async function clearSearchData(event) {
      setloadTableData(false);
      event.preventDefault();
      let totalParams;
      let startFrom= 0;
      let cpage;
      let searchFormData={};
      let getURL
      switch (key) {
        case pageLayoutData[1].subComponentsItems.tabName1:
          default:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
          break;
        case pageLayoutData[1].subComponentsItems.tabName2:
          getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
          break;
      }
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      }     
        totalParams = { ...totalParams, mode: key }
        totalParams = {...totalParams, start_from: startFrom}
      for (let formElementIdentifier in formValues) {
        if(formValues[formElementIdentifier].elementType === 'multiselect') {
          if((formValues[formElementIdentifier].value)) {
            let arrayConvert = [];
            formValues[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
          }
        else
          searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
      }
      totalParams = {...totalParams, ...dynamicParameters, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        let paramsConverted = new URLSearchParams(totalParams);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        setsearchInputValue();
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          actionsColumn(responseDataJson)
          setpage(1);
          switch (key) {
            case pageLayoutData[1].subComponentsItems.tabName1:
              default:
                setAssignedColumns(responseDataJson.data.columns); 
                setAssignedProductsData(responseDataJson.data.data);
                setAssignedRecords(responseDataJson.data.recordsTotal)
                break;
                case pageLayoutData[1].subComponentsItems.tabName2:
                  setDownloadedColumns(responseDataJson.data.columns); 
                  setDownloadedProductsData(responseDataJson.data.data)
                  setDownloadedRecords(responseDataJson.data.recordsTotal)
              break;
          }
          setSelectedValue(1);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setformValues(pageLayoutData[0].formValues);
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
       setsearchInputValue();
        let responseData = await PostAPI(getURL, totalParams);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          setpage(1);
          switch (key) {
            case pageLayoutData[1].subComponentsItems.tabName1:
              default:
                setAssignedColumns(responseDataJson.data.columns); 
                setAssignedProductsData(responseDataJson.data.data);
                setAssignedRecords(responseDataJson.data.recordsTotal)
                break;
                case pageLayoutData[1].subComponentsItems.tabName2:
                  setDownloadedColumns(responseDataJson.data.columns); 
                  setDownloadedProductsData(responseDataJson.data.data)
                  setDownloadedRecords(responseDataJson.data.recordsTotal)
              break;
          }
          setSelectedValue(1);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setformValues(pageLayoutData[0].formValues);
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    };
    return (
      <div>
        <MDBCol md="4" className="mb-4">
          <input
            onKeyPress={(e) => changeInputFunction(e,input)}
            onKeyDown={(e) => clearchangeInputFunction(e,input)}
            className="form-control"
            style={{ backgroundColor: 'white' }}
            placeholder={`${t("search")}`}
            ref={n => input = n}
            type="text"
            defaultValue={searchInputValue}
          />
        </MDBCol>
        <MDBCol md="4" className="mb-4">
          {/* {(showCSearch == false) && <ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName="Search" /> }  */}
          {<ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName={`${t("search")}`} /> } 
          {(showCSearch == true) && <ButtonField color="info" key="ModalCLRBTN" submit={ (e) => clearSearchData(e) } BName={`${t("clear")}`} />} 
        </MDBCol>
        <MDBCol md="1" className="mb-1"></MDBCol>
      </div>
    );
  };


  async function handleLatestTableData(page) {
    setloadTableData(false);
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
            break;
          case pageLayoutData[1].subComponentsItems.tabName2:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
            break;
        }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    } 
    totalParams = { ...totalParams, mode: key }
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in formValues) {
      if(formValues[formElementIdentifier].elementType === 'multiselect') {
        if((formValues[formElementIdentifier].value)) {
          let arrayConvert = [];
          formValues[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
    }
    if(page == 1) {
      let startFrom = 0;
      totalParams.start_from = startFrom;
    }else {
      cpage = page -1;
      startFrom = cpage * sizePerPage;
      totalParams.start_from = startFrom;
    }
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined ){
      getURL = getURL + '&index=' + page;
      }
      else{
      getURL = getURL + '&element=' + searchInputValue+'&index=' + page;
      }
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        actionsColumn(responseDataJson)
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObjSearch;
      let newestObj = {...newObj, index:page}
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObjSearch = {...newestObj}
      else
      newestObjSearch = {...newestObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObjSearch);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function getLatestTableData() {
    setformValues(pageLayoutData[0].formValues);
    setshowFilter(false)
    setloadTableData(false);
    setsearchInputValue();
    setshowCSearch(false);
    let totalParams;
    let getURL
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
            break;
          case pageLayoutData[1].subComponentsItems.tabName2:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
            break;
        }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    totalParams = { ...totalParams, mode: key }
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + '&index=' + page;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        actionsColumn(responseDataJson)
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setIotQty(pageLayoutData[1].title1 === 'Assign' ? responseDataJson.data.IOTQty :responseDataJson.data.availableQty)
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newObj = {...totalParams, index:page}
      let responseData = await PostAPI(getURL, newObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function delelteData(URL) {
    const getresponse = await FetchAPI(URL);
    const getresponseJson = await getresponse.json();
    const responseData = getresponseJson.data;
  }

  const openFilter = () => {
    setshowFilter(!showFilter);
    let URL= pageLayoutData[0].hasOwnProperty('filterEndPoint') ? 
            pageLayoutData[0].filterEndPoint: 'not found'
    let totalParams={};
    if(pageLayoutData[0].extraParametersDropdown !== null) {
      const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
      totalParams = {...totalParams, ...extraParametersDropdown}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    let modifiedTab;
    switch(key){
      case pageLayoutData[1].subComponentsItems.tabName1:
      default:
        modifiedTab = pageLayoutData[1].subComponentsItems.tabName1.replace(/\s/g, '')
        totalParams = { ...totalParams, mode: modifiedTab }
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        modifiedTab = pageLayoutData[1].subComponentsItems.tabName2.replace(/\s/g, '')
        totalParams = { ...totalParams, mode: modifiedTab }
        break;
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(URL !== 'not found') {
    let paramsConverted = new URLSearchParams(totalParams);
    URL = (`${URL}?${paramsConverted.toString()}`);
    setDropDownApi(URL);
    }else 
    setDropDownApi('not found')
  }

  const open = () => {
    setuniqueId();
    setModalWidth(pageLayoutData[0].addButtonItems.className);
    setmodalType(!(pageLayoutData[1].title2 === 'Bulk Download') && `${t("add")}`);
    setModalTitle(pageLayoutData[0].addButtonName);
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonNameEn) : setCommonTitle(pageLayoutData[0].addButtonName)
    setModalformValues(pageLayoutData[0].addButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language);
    setshowModal(true);
    (pageLayoutData[0].addButtonItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addButtonItems.Table) : 
        setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty('headers') ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
  }
  const openImport = () => {
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
  }
  const openImport1 = () => {
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
  }

  const close = () => {
    setshowModal(false);
  }

  const updateGridRecord = async(id, status) => {
    setloadTableData(false)
      const updatedGridData = downloadedProductsData.map(data => {
        if(id === data.id){
          data.reload = status
          data.sync_time = moment().format('YYYY-MM-DD HH:mm:ss')
          data.status = status === 1 ? "Synced" : "Sync failed"
          data.type = "Manual"
          data.action = <div className="action-styles" >
          {<i onClick={(e) => handleSyncToSap(data)} className={`fa fa-info-circle refresh-icon ${status == 2 || status == 0 ? "refresh-warn" : ""}`}/>}
          {(status == 0 || status == 2)&& <i onClick={(e) => handleSyncReload(data)} className={`fa fa-refresh refresh-icon`} />} 
        </div>
        }
        return data
      })
      setloadTableData(true) 
      setDownloadedProductsData(updatedGridData)
  }
  
  const getSyncReload = async(value) => {
    const payloadObj = {
      id: value.id,
      delivery_id: value.delivery_id,
      reload: value.reload
    }
    setIsLoader(true)
    const response = await PostAPI(pageLayoutData[1].subComponentsItems.saveApiEndPoint,payloadObj)
    if(response.status === 200){
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status:response?.data?.Status,message: response?.data?.Message})
      updateGridRecord(value.id,response?.data?.Status)
    }else{
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
    }
  }
  
  useEffect(() => {
      if (disableReloadIcon && syncValue !== null) {
        getSyncReload(syncValue)
      }
  }, [disableReloadIcon, syncValue])
  
  const closeTPModal = () => {
    setshowTPModal(false);
  }
  
  async function syncInventory(e) {
    let getURL = pageLayoutData[1].subComponentsItems.syncApiEndPoint
    const customerId = cookies.get('customer_id');
    const location_id = cookies.get('userLocation_id');
    const user_role_name = cookies.get('userRole_name');
    const user_id = cookies.get('user_id');
    if(customerId == 15){
      const payload = {
        location_id,
        user_role_name,
        user_id
      }
      const paramsConverted = new URLSearchParams(payload);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
    }
    setIsLoader(true)
    setDisabledButton(true)
    let responseData = await FetchAPI(getURL);
    if(responseData.status === 200){
      let getresponseJson = await responseData.json()
      setDisabledButton(false)
      setIsLoader(false)
      getStatusAlert({status: getresponseJson?.Status,message: getresponseJson?.data,reCallGrid: getLatestTableData})
    }else{
      setDisabledButton(false)
      setIsLoader(false)
      getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
    }
  }
  
  const getSyncToSapGridColumns = (data) => {
    const columns = data.map(column => {
      let arr = []
      for (let key in column) {
        let keyText = key.split("_").join(" ").toUpperCase()
        arr.push({ dataField: key, text: keyText })
      }
      return [...arr]
    })
    setColumnsChild(columns[columns.length - 1]);
  }
  const modifySyncToSapJson = (inputJson) => {
    const title = pageLayoutData[1].title1;
    if (cookies.get('customer_id') == 15 || cookies.get('customer_id') == 17) {
      let Del_no, Plant, From_storageloc, Rec_storageloc
      if (title === "Dispatch Sync to" || title === "Receive GRN to") {
        const { del_no, plant } = inputJson[0];
        Del_no = del_no;
        Plant = plant;
      } else if (title === "Inventory Sync to") {
        const { plant, from_storageloc, rec_storageloc } = inputJson[0];
        Plant = plant;
        From_storageloc = from_storageloc;
        Rec_storageloc = rec_storageloc;
      }
      const mergedData = inputJson[0].data.map(item => {
        if (title === "Dispatch Sync to" || title === "Receive GRN to") {
          return {
            ...item,
            Del_no,
            Plant
          }
        }
        return {
          ...item,
          Plant,
          From_storageloc,
          Rec_storageloc,
        }
      });
      getSyncToSapGridColumns(mergedData)
      return mergedData
    } else {
      getSyncToSapGridColumns(inputJson)
      return inputJson;
    }
  }
  
  const handleSyncReload = async(value) => {
    setSyncValue(value);
    setDisableReloadIcon(true);
  }
  
  const handleSyncToSap = (value) => {
    setSyncSapMessage({
      status: value?.status,
      message: value?.message
    })
    const inputJson = JSON.parse(value.input)
    const result = modifySyncToSapJson(inputJson)
    setproductsDataChild(result);
    setModalTitle("List");
    setloadTableDataChild(true);
    setshowTPModal(true);
  }

  const editOpenModal = (event, id, extraId) => {
    setModalTitle(pageLayoutData[0].addButtonName);
    (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    let editURL = '';

      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
      setmodalgetURL(editURL);
      setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'));
    setModalWidth(pageLayoutData[0].editButtonItems.className);
    setmodalType(`${t('edit')}`);
    setuniqueId(id);
    setextraId(extraId);
    setshowModal(true);
  }
  async function exportOpenModal (e, value)  {
    e.preventDefault();
    setmodalType('');
    setuniqueId(value.id)
    setModalTitle(pageLayoutData[0].addTextName);
    setModalWidth(pageLayoutData[0].addTextItems.className);
    setModalformValues(pageLayoutData[0].addTextItems.formValues);
    setshowModal(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id'));
    setSaveUrl(pageLayoutData[0].addTextItems.exportEndPoint)
    setshowModal(true);
    (pageLayoutData[0].addTextItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addTextItems.Table) : 
        setTable(false));
    (pageLayoutData[0].addTextItems.hasOwnProperty('headers') ? 
        setHeaders(pageLayoutData[0].addTextItems.headers) : 
        setHeaders(null));
}
 
  const deleteOpenModal = (event, value) => {
    let uniqueId = '';
    let delURL = '';
      uniqueId = value.id;
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    let msg = '';
    swal({title:`${t("alerts.sure")}`, text:`${t("alerts.deleted_not_recovered")}`, icon:"warning", buttons: true, dangerMode: true,}) 
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal("Poof! Your data has been deleted!", {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal("Your data is safe!", {
          timer: 2000,
          button: false
        });
      }
    });
  }

  const handleReportActions = async(value, type) => {
    let payload;
    switch(type){
      case "download":
        if(value.status === "Processing"){
          getStatusAlert({status: 3,message: "Please wait...We are processing your request.",reCallGrid: getLatestTableData})
          return;
        }
        window.location.href = value.s3_link;
        break;
      case "mail":
        let getURL = pageLayoutData[1]?.subComponentsItems?.apiEndPoint3
        payload = {...dynamicParameters, id: value.id, email: localStorage.getItem('email')}
        const paramsConverted = new URLSearchParams(payload);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        setIsLoader(true)
        const response = await FetchAPI(getURL);
        const responseJson = await response.json();
        if(response.status === 200){
          getStatusAlert({status: responseJson?.data?.status,message: responseJson?.data?.message})
          setIsLoader(false)
        }else{
          setIsLoader(false)
          getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
        }
        break;
      default:
        return;
    }
  }


  
  useEffect(() => {
    (async () => {
      if (pageLayoutData != 'undefined') {
        if(pageLayoutData[1] && pageLayoutData[1].hasOwnProperty('subComponentsItems')) {
        setformValues(pageLayoutData[0].formValues);
        setShowParentContent(true);
        setshowFilter(false);
        setloadTableData(false);
        setsearchInputValue();
        setshowCSearch(false);
        setpage(1);
        let totalParams;
        let getURL
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
            break;
          case pageLayoutData[1].subComponentsItems.tabName2:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
            break;
        }
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          if(key === "failed"){
            extraParameteres["mode"] = "failed";
          }
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
          console.log("firstTimeParameters:",firstTimeParameters)
        }
        console.log("dynamicParameters:",dynamicParameters)
        totalParams = {...totalParams, ...dynamicParameters}
        totalParams = { ...totalParams, mode: key }
        if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          if(key === "download"){
            setValues("")
          }
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            if(responseDataJson.data.hasOwnProperty('addPermission'))
            setAddButtonPermission(responseDataJson.data.addPermission)
            actionsColumn(responseDataJson)
            switch (key) {
              case pageLayoutData[1].subComponentsItems.tabName1:
                default:
                  setAssignedColumns(responseDataJson.data.columns); 
                  setAssignedProductsData(responseDataJson.data.data);
                  setAssignedRecords(responseDataJson.data.recordsTotal)
                  setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
                  break;
                  case pageLayoutData[1].subComponentsItems.tabName2:
                    setDownloadedColumns(responseDataJson.data.columns); 
                    setDownloadedProductsData(responseDataJson.data.data)
                    setDownloadedRecords(responseDataJson.data.recordsTotal)
                    setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
                break;
            }
            setSelectedValue(1);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setSyncPermission(responseDataJson?.data?.syncPermission)
            setformValues(pageLayoutData[0].formValues);
            setIotQty(pageLayoutData[1].title1 === 'Assign' ? responseDataJson.data.IOTQty :responseDataJson.data.availableQty)
            setloadTableData(true);
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
            switch (key) {
              case pageLayoutData[1].subComponentsItems.tabName1:
                default:
                  setAssignedColumns(responseDataJson.data.columns); 
                  setAssignedProductsData(responseDataJson.data.data);
                  setAssignedRecords(responseDataJson.data.recordsTotal)
                  break;
                  case pageLayoutData[1].subComponentsItems.tabName2:
                    setDownloadedColumns(responseDataJson.data.columns); 
                    setDownloadedProductsData(responseDataJson.data.data)
                    setDownloadedRecords(responseDataJson.data.recordsTotal)
                break;
            }
            setSelectedValue(1);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setformValues(pageLayoutData[0].formValues);
            setloadTableData(true);
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }
        }
        (pageLayoutData[0].addButton == true && setModalformValues(pageLayoutData[0].addButtonItems.formValues));
      }
    }
    })()
  }, [key,pageLayoutData])

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
      setKey(pageLayoutDataContext[1].subComponentsItems.tabName1)
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);
  
  async function exportResModal (e, value) {
    e.preventDefault();
    setProp(value.download_token)
    setmodalType('');
    setuniqueId(value.po_number)
    setModalTitle(pageLayoutData[0].addTextName1);
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addTextNameEn) : setCommonTitle(pageLayoutData[0].addTextName1 )
    setModalWidth(pageLayoutData[0].addTextItems1.className);
    setModalformValues(pageLayoutData[0].addTextItems1.formValues);
    setshowModal(true);
    if (pageLayoutData[0].addTextName1 === 'Download Reclamation PO') {
      setSaveUrl(pageLayoutData[0].addTextItems1.exportEndPoint1 + '?customer_id=' + cookies.get('customer_id') + "&id=" + value.po_number + '&user_id=' + cookies.get('user_id') + '&email=' + localStorage.getItem('email')
        + '&userLocation_id=' + cookies.get('userLocation_id') + '&userRole_name=' + localStorage.getItem('userRole_name') + '&language=' + language)
    }else{
    setSaveUrl(pageLayoutData[0].addTextItems1.exportEndPoint1 + '?customer_id='+cookies.get('customer_id') + (featureId === 1 ? cookies.get('customer_id') == "15" ? "&id=" + value.id :"&id=" + value.po_number : "&id=" + value.download_token)
      + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email')
      + '&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ localStorage.getItem('userRole_name')+ '&language='+ language)
    }
  }
  const openModalExtra = () => {
    setmodalType(`${t("add")}`);
    setModalTitle(pageLayoutData[0].addButtonNameExtra);
    setModalWidth(pageLayoutData[0].addButtonItemsExtra.className);
    setModalformValues(pageLayoutData[0].addButtonItemsExtra.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItemsExtra.saveApiEndPoint)
    setDropDownApi(pageLayoutData[1].subComponentsItems.getExtraModalDropdowns+ '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')); 
    setshowModal(true);
  }
  
  async function exportPdf(e, url) {
    e.preventDefault();
    window.location.href = url;
  }

  async function filteredExport2(data) {
    setValues(data)
  }
  
  async function exportFile(e,type) {
    e.preventDefault();
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }
    const getURL = pageLayoutData[0].exportApiEndPoint ? 
    pageLayoutData[0].exportApiEndPoint : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in values) {
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[0].hasOwnProperty('extraParametersDropdown')) {
        const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
        dataObject = {...dataObject, ...extraParametersDropdown}
      }
      if (type === "IOT Export") {
        dataObject = { ...dataObject, report_name: pageLayoutData[1].title1 }
        const endpoint = pageLayoutData[0]?.iotExportApiEndPoint
        setIsLoader(true);
        const response = await PostAPI(endpoint, dataObject)
        if (response.status === 200) {
          setIsLoader(false);
          getStatusAlert({ status: response?.data?.status, message: response?.data?.message })
        } else {
          setIsLoader(false);
          getStatusAlert({ status: 404, message: `${t("alerts.something_went_wrong1")}`, buttonText: `${t("alerts.ok")}` })
        }
        return;
      }
      else if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        setIsLoader(true)
        getresponse = await FetchAPI(newgetURL);
        getresponseJson = await getresponse.json()
        setIsLoader(false)
        if("Location" in getresponseJson?.data){
          window.location.href = getresponseJson?.data?.Location
        }
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
      }
    }
    if(getresponse.status == 200){
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
    }
    else{
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
  }

  const handlePageChange = (e) => {
    setSelectedValue(e.target ? e.target.value : e);
    handleLatestTableData(e.target ? e.target.value : e);
  };

  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: Number(selectedValue),
    totalSize: key === pageLayoutData[1]?.subComponentsItems?.tabName1 ? assignedRecords : downloadedRecords
  }

  const RemotePagination = ({ data, page, sizePerPage, onTableChange, totalSize, baseValue }) => (
    <div>
      <BootstrapTable
        remote
        keyField="id"
        striped
        hover
        condensed
        bordered={false}
        {...baseValue}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        noDataIndication={`${t("no_data")}`}
        wrapperClasses="table-responsive overflow-class"
      />
      {selectOption > 0 && (
        <div
          className="Dropdown"
          style={{
            marginTop: "-45px",
            position: "absolute",
            fontSize: "13px",
          }}
        >
          <p style={{ float: "left", fontSize: "13px" }}>{t("Page No:")}</p>

          <select
            onChange={handlePageChange}
            value={selectedValue}
          >
            {Array.from(Array(selectOption), (e, i) => {
              return (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              );
            })}
          </select>
        </div>
      )}
    </div>
  );

return (
  (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 17) ?
  <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                hCenter = {(`${pageLayoutData[1].title3} : `)}
                iotQty = {iotQty}
                button ={(pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'modal') ? <ButtonField color="info" submit={() => open()} BName={(pageLayoutData[1].title2 === 'Bulk Download' || pageLayoutData[1].title1 === 'Assign'  ? '':`${t('download')} `)+ pageLayoutData[0].addButtonName} /> : ''}
                title={(pageLayoutData[1]) ? pageLayoutData[1].title1 : ''}
                title2={(pageLayoutData[1]) ? pageLayoutData[1].title2 :''}
            content={
                 <Tabs
                     id="controlled-tab-example"
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                      defaultActiveKey={pageLayoutData[1].subComponentsItems.tabName1}
                  >
                  <Tab eventKey={pageLayoutData[1].subComponentsItems.tabName1} title={pageLayoutData[1].subComponentsItems.apiTabName1}>
                    <br></br>
                    {showModal ?
                        <ModalBox
                          key={ pageLayoutData[0].featureId }
                          showModal={showModal}
                          titlePreFix = { `${t('add')}` }
                          modalWidth = { modalWidth}
                          title={ modalTitle }
                          formValue={ModalformValues}
                          addURL={ saveUrl }
                          getURL={ modalgetURL }
                          uniqueid={ uniqueId }
                          commonTitle = {commonTitle}
                          extraId = {extraId}
                          prop = {prop}
                          drpdwnApi = {pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? dropDownApi : 'not found' }
                          recallMehod= { getLatestTableData }
                          hide={close} 
                          headers = {headers}
                          table = {table}
                        />
                        : ''}
                {showParentContent &&
                  <ToolkitProvider
                    keyField="id"
                    data={assignedProductsData}
                    columns={assignedColumns}
                    search
                    exportCSV
                  >
                    {
                      props => (
                        <div>
                          <MDBRow>
                           {pageLayoutData[1].subComponentsItems.isSearch === false ? null : <MySearch {...props.searchProps} /> }
                            <br></br>
                            <br></br>
                            <br></br>
                            {pageLayoutData[1].subComponentsItems.isQuantity === false ? null : <MDBCol md="2" className="mb-6" style={{marginBottom:"4rem"}}>
                            <div className="custom-form-cntrl">
                                <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={{fontWeight: '400',textAlignVertical: "center",textAlign: "center",marginTop:"-7px"}}>{`${t('total')}  ${pageLayoutData[1].subComponentsItems.apiTabName1}`}</label>
                                <input type="text"  className="form-control" readOnly="readOnly" style={{marginTop:"-7px",marginInlineStart:"1rem",width:"7em"}} value={assigned}/>
                                </div>
                            </MDBCol>}
                            <MDBCol md="12" className="mb-12">
                            {loadTableData ?
                              <div style={{float: 'right'}}>
                                {(pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" submit={(e) => exportFile(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[0].iotExportButton === true && <ButtonField color="info" submit={(e) => exportFile(e,"IOT Export")} BName={"IOT Export"} />)}
                                {(pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" key="Filter" submit={() => openFilter()} BName={`${t("filter")} `} /> : ''}
                                {(pageLayoutData[0].addButtonExtra === true) ? <ButtonField color="info" submit={() => openModalExtra()} BName={`${t("add")} `+ pageLayoutData[0].addButtonNameExtra} /> : ''}
                                {(pageLayoutData[0].importButton === true) ? <ButtonField color="info" submit={() => openImport()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName} /> : ''}
                                {(pageLayoutData[0].importButton1 === true) ? <ButtonField color="info" submit={() => openImport1()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName1} /> : ''}
                              </div>
                            : ''
                            }
                            </MDBCol>
                            </MDBRow>
                            {showFilter ?
                              <FilterBox
                                key="FilterBox"
                                formValue={formValues}
                                setformValues = { setformValues }
                                setSelectChildValue={setSelectChildValue}
                                change={inputChangedHandler}
                                searchClick={ searchTableData }
                                filteredExport = {filteredExport}
                                filteredExport1 = {filteredExport1}
                               filteredExport2 = {filteredExport2}
                                selectChildValue={selectChildValue}
                                clearClick={clearTableData}
                                title={pageLayoutData[1].title1}
                                dropDownApi = {dropDownApi}
                                validate={validator} 
                                exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                                exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true ? true : false}
                                exportFilterButtonName1={pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true ? pageLayoutData[0].exportFilterButtonName1 : ''}
                                exportApiEndPoint={pageLayoutData[0].exportApiEndPoint ? 
                                  pageLayoutData[0].exportApiEndPoint : 'not found'}
                              />
                            : ''}
                            {loadTableData ?
                            <>
                            <div>
                            <BootstrapTable 
                            remote
                            striped
                            hover
                            condensed
                            keyField='name'
                            data={ assignedProductsData }
                            columns={ assignedColumns }
                            bordered={ false }
                            pagination={ paginationFactory(options) }
                            onTableChange={ handleTableChange }
                            wrapperClasses="table-responsive overflow-class"
                            noDataIndication={t("no_data")}
                          /> 
                                {selectOption > 0 && (
                                  <div
                                    className="Dropdown"
                                    style={{
                                      marginTop: "-45px",
                                      position: "absolute",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <p style={{ float: "left", fontSize: "13px" }}>{t("Page No:")}</p>

                                    <select
                                      onChange={handlePageChange}
                                      value={selectedValue}
                                    >
                                      {Array.from(Array(selectOption), (e, i) => {
                                        return (
                                          <option key={i + 1} value={i + 1}>
                                            {i + 1}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                )}
                          </div>
                          {isLoader && <div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                          </>
                              : 
                              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              { error ?   
                              <h4> { errorMsg } </h4> 
                              : 
                              <LoadingSpinner /> 
                              }
                              </div>
                            }
                          </div>
                        )}
                  </ToolkitProvider>
                }
                </Tab>
                <Tab eventKey={pageLayoutData[1].subComponentsItems.tabName2} title={pageLayoutData[1].subComponentsItems.apiTabName2}>
                <br></br>
                {showParentContent ?
                  <ToolkitProvider
                    keyField="id"
                    data={downloadedProductsData}
                    columns={downloadedColumns}
                    search
                    exportCSV
                  >
                    {
                      props => (
                        <div>
                          <MDBRow>
                            {pageLayoutData[1].subComponentsItems.isSearch === false ? null : <MySearch {...props.searchProps} /> }
                            <br></br>
                            <br></br>
                            <br></br>
                            {pageLayoutData[1].subComponentsItems.isQuantity === false ? null :<MDBCol md="2" className="mb-6" style={{marginBottom:"4rem"}}>
                            <div className="custom-form-cntrl">
                            <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={{fontWeight: '400',textAlignVertical: "center",textAlign: "center",marginTop:"-7px"}}>{`${t('total')}  ${pageLayoutData[1].subComponentsItems.apiTabName2}`}</label>
                                <input type="text"  className="form-control" readOnly="readOnly" style={{marginTop:"-7px",width:"7em",marginInlineStart:"1em"}} value={downloaded}/>
                                </div>
                            </MDBCol>}
                            <MDBCol md="12" className="mb-12">
                            {loadTableData ?
                              <div style={{float: 'right'}}>
                                {((syncPermission === true && pageLayoutData[1].title1 == "Inventory Sync to")) ? <button disabled={disabledButton} onClick={(event) => syncInventory(event)} className="btn btn-outline-primary btn-rounded waves-effect" style={{borderRadius: 15}}>{'Sync Data'}</button> : ''}
                                {(pageLayoutData[1].subComponentsItems.tabName2 !== "download" && pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" submit={(e) => exportFile(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[1].subComponentsItems.tabName2 !== "download" && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" key="Filter" submit={() => openFilter()} BName={`${t("filter")} `} /> : ''}
                                {(pageLayoutData[0].addButtonExtra === true) ? <ButtonField color="info" submit={() => openModalExtra()} BName={ "Add "  + pageLayoutData[0].addButtonNameExtra} /> : ''}
                                {(pageLayoutData[0].importButton === true) ? <ButtonField color="info" submit={() => openImport()} BName={"Import "+ pageLayoutData[0].importButtonName} /> : ''}
                                {(pageLayoutData[0].importButton1 === true) ? <ButtonField color="info" submit={() => openImport1()} BName={+ pageLayoutData[0].importButtonName1} /> : ''}
                              </div>
                            : ''
                            }
                            </MDBCol>
                            </MDBRow>
                            {pageLayoutData[1].title1 !== "Dispatch" && showFilter ?
                              <FilterBox
                                key="FilterBox"
                                formValue={formValues}
                                setformValues = { setformValues }
                                setSelectChildValue={setSelectChildValue}
                                change={inputChangedHandler}
                                searchClick={ searchTableData }
                                filteredExport = {filteredExport}
                                filteredExport1 = {filteredExport1}
                                filteredExport2 = {filteredExport2}
                                selectChildValue={selectChildValue}
                                clearClick={clearTableData}
                                title={pageLayoutData[1].title1}
                                dropDownApi = {dropDownApi}
                                validate={validator} 
                                exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                                exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true ? true : false}
                                exportFilterButtonName1={pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true ? pageLayoutData[0].exportFilterButtonName1 : ''}
                                exportApiEndPoint={pageLayoutData[0].exportApiEndPoint ? 
                                  pageLayoutData[0].exportApiEndPoint : 'not found'}
                              />
                            : ''}
                            {loadTableData ?
                            <>
                              <RemotePagination
                                page={page}
                                sizePerPage={sizePerPage}
                                totalSize={downloadedRecords}
                                baseValue={props.baseProps}
                                onTableChange={handleTableChange}
                              />
                              {isLoader && <div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                              </>
                              : 
                              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              { error ?   
                              <h4> { errorMsg } </h4> 
                              : 
                              <LoadingSpinner /> 
                              }
                              </div>
                            }
                          </div>
                        )}
                  </ToolkitProvider> : " "}
                </Tab>
                  </Tabs>
                }
          />
            {showTPModal ?
              <Modal show={showTPModal} onHide={closeTPModal} dialogClassName={"modal-90w"} backdrop="static" keyboard={false}>
                <Modal.Header closeButton className="modal-close-button" >
                  <Modal.Title>{tpPermission && "TP:"}
                    <a href='#!' className='font-weight-bold' style={{ color: 'white' }}>
                      <strong> {modalTitle}</strong>
                    </a>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                  <MDBRow>
                    <MDBCol md={tpPermission ? "4" : "12"} className="mb-4">
                      {loadTableDataChild ?
                        <ToolkitProvider
                          keyField="id"
                          data={productsDataChild}
                          columns={columnsChild}
                        >
                          {props => (
                            <div>
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                                bordered={false}
                                pagination={productsDataChild.length > 10 ? paginationFactory({ hideSizePerPage: true }) : ''}
                                height={productsDataChild.length > 10 ? 510 : false}
                                noDataIndication={t("no_data")}
                                wrapperClasses="table-responsive overflow-class"
                                headerClasses="grid-header"
                              />
                              {(syncSapMessage.status === "Sync failed" && syncSapMessage.message) && <div className="sync-sap-message" ><p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {syncSapMessage.message}</p></div>}
                            </div>
                          )}
                        </ToolkitProvider>
                        :
                        <div>
                        </div>
                      }
                    </MDBCol>
                    <MDBCol md="8" className="mb-8"  >
                    </MDBCol>
                  </MDBRow>
                </Modal.Body>
                <Modal.Footer>
                  <MDBRow className='d-flex align-items-center mb-4'>
                    <div className='text-center mb-3 row'>
                      <ButtonField submit={closeTPModal} color="info" BName="Close" />
                    </div>
                  </MDBRow>
                </Modal.Footer>
              </Modal>
              : isLoader && <div className="beat-loader" ><BeatLoader color={"#3C423C"} /></div>
            }
            </Col>
          </Row>
        </Grid>


      </div>
      : <div className="content">
      <Grid fluid>
        <div className="text-center" style={{ margin:"80px" }}><LoadingSpinner /></div>
      </Grid>
    </div>
  );
}

export default Role;
